module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/thurston_cover.9cf443c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/thurston_cover.jpg
// module id = 4T69
// module chunks = 1